import { CoachbotCardTemplate } from "../types";
import AllianzLogo from "resources/images/Allianz_logo.png";

export const ONE_WEEK_SMART_GOAL_TEMPLATE: CoachbotCardTemplate = {
  title: "Growth Mindset Check-In",
  description:
    "Track your Growth Mindset practice, celebrate wins, and commit to specific actions aligned with the Allianz Growth Mindset framework.",
  image: AllianzLogo,
  coachBotIntro:
    "Welcome to your Growth Mindset Chat. This is a great opportunity each week to reflect on how you've been embodying Allianz's Growth Mindset Attributes. Which aspect would you like to explore first?",
  preSelectedPrompts: [
    "Reflect on my Growth Mindset actions last week",
    "Plan my Growth Mindset focus for this week",
    "Celebrate a Teammate's Growth Mindset",
  ],
  chatType: "allianzGrowthMindsetChat",
  className: "custom-company-prompt",
};

export const ALL_ALLIANZ_COACHBOT_PROMPT_TEMPLATES = {
  "For Allianz": {
    promptTemplates: [ONE_WEEK_SMART_GOAL_TEMPLATE],
  },
} as const;
